import { render, staticRenderFns } from "./ControlLocalizedInput.vue?vue&type=template&id=74c8ec80&"
import script from "./ControlLocalizedInput.vue?vue&type=script&lang=js&"
export * from "./ControlLocalizedInput.vue?vue&type=script&lang=js&"
import style0 from "./ControlLocalizedInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports